import React from 'react';
import { Box, Container, Fade } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import Navbar from './Navbar';

const PageLayout = ({ 
  children, 
  maxWidth = "lg", 
  showNavbar = true,
  background = "default",
  sx = {}
}) => {
  const { isAuthenticated } = useAuth();
  const shouldShowNavbar = showNavbar && isAuthenticated;

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        backgroundColor: background === 'default' ? 'background.default' : background,
        position: 'relative'
      }}
    >
      {shouldShowNavbar && <Navbar />}
      
      <Container 
        maxWidth={maxWidth} 
        sx={{ 
          pt: shouldShowNavbar ? 6 : 4, // Increased top padding
          pb: 6, // Increased bottom padding
          px: { xs: 3, sm: 4, md: 5 }, // Better responsive padding
          position: 'relative',
          ...sx
        }}
      >
        <Fade in timeout={600}>
          <Box>
            {children}
          </Box>
        </Fade>
      </Container>
      
      {/* Subtle background decoration */}
      <Box sx={{
        position: 'fixed',
        top: 0,
        right: 0,
        width: '50%',
        height: '100%',
        background: (theme) =>
          `linear-gradient(135deg, transparent 0%, ${theme.palette.primary.main}08 100%)`,
        pointerEvents: 'none',
        zIndex: -1
      }} />
    </Box>
  );
};

export default PageLayout;